export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/wmd-logo-event-english-fa2b80e6f48d1d5d4a3d4751cea60c42.svg";